
const Constans = {
    ANALYZE_STARTED: 'analyze-started',
    ANALYZE_FINISHED: 'analyze-finished',
    CLEANING_PAUSED: 'clean-pause',
    CLEANING_COMPLETE: 'clean-complete',
    CLEANING_STARTED: 'clean-started',
};

export { Constans };